<script lang='ts'>
    import lang from '../../lang/language';
    import type {ServiceType} from '../../store/types';
    import Map from '../../shared_components/Map.svelte';
    import ImageSlider from '../../shared_components/ImageSlider.svelte';
    import AddToWishlistButton from '../../shared_components/AddToWishlistButton.svelte';
    import {formatMoney} from '../../helpers/common';
    import {currentLangIsJapanese} from '../../helpers/url';
    import ModalBox from "../../shared_components/ModalBox.svelte";

    export let selectedService: ServiceType;

    let showImageModal = false;
    let updateImageSlider = 2;
    let zoomImage = '';


    function toggleImageModal(value){
        updateImageSlider++;
        showImageModal = value;
    }



    function getServiceType() {
        let serviceType = '';
        switch (selectedService.Type) {
            case 0:
                serviceType = lang.accommodation;
                break;
            case 1:
                serviceType = lang.activity;
                break;
            case 2:
                serviceType = lang.restaurant;
                break;
            case 3:
                serviceType = lang.produce;
                break;
            default:
                return lang.accommodation;
        }

        return serviceType;
    }
</script>

<div class='details-wrapper'>
    <ModalBox show={showImageModal} toggleCallback={toggleImageModal}>
        <img src={zoomImage} alt="zoom img" width="100%" class="zoom-img">
    </ModalBox>
    <div class='details-inner'>
        <div class='row center-align relative'>
            <ImageSlider images={selectedService.Images} imageCallback={(img) => {toggleImageModal(true);zoomImage=img}}/>
        </div>
        <div class="row left-align">
            <h1 style="display: inline-block">
                {selectedService.Name}
                <div class="like-button-box">
                    <AddToWishlistButton service={selectedService}/>
                </div>
            </h1>
        </div>
        <div class='long-desc left-align'>
            {@html selectedService.LongDesc}
        </div>
        <div class='row'>
            <div class='row left-align primary-font-color subtitle'>
                <h2>{lang.basic_info}</h2>
            </div>
        </div>
        <div>
            <div class='row left-align table-row'>
                <div class='caption'>{lang.name}</div>
                <div class='value'>{selectedService.Name}</div>
            </div>
            {#if (selectedService.Price)}
                <div class='row left-align table-row'>
                    <div class='caption'>{lang.price}</div>
                    <div class='value'>
                        {!currentLangIsJapanese() && selectedService.Price > 0 ? lang.from : ''}
                        ¥{formatMoney(selectedService.Price)}
                        {currentLangIsJapanese() && selectedService.Price > 0 ? lang.from : ''}
                    </div>
                </div>
            {/if}
            <div class='row left-align table-row'>
                <div class='caption'>{lang.address}</div>
                <div class='value'>{selectedService.Address}</div>
            </div>
            {#if (selectedService.Phone)}
                <div class='row left-align table-row'>
                    <div class='caption'>{lang.phone}</div>
                    <div class='value'>{selectedService.Phone}</div>
                </div>
            {/if}
            {#if (selectedService.Fax)}
                <div class='row left-align table-row'>
                    <div class='caption'>{lang.fax}</div>
                    <div class='value'>{selectedService.Fax}</div>
                </div>
            {/if}
            {#if (selectedService.Website)}
                <div class='row left-align table-row'>
                    <div class='caption'>{lang.website}</div>
                    <div class='value'>
                        <a href="{selectedService.Website}" target="_blank">{selectedService.Website}</a>
                    </div>
                </div>
            {/if}
            {#if (selectedService.PublicEmail)}
                <div class='row left-align table-row'>
                    <div class='caption'>{lang.email}</div>
                    <div class='value'>
                        <a href="mailto:{selectedService.PublicEmail}?subject=Mail from Our Site" target="_blank">
                            {selectedService.PublicEmail}
                        </a>
                    </div>
                </div>
            {/if}
        </div>
        <!-- Map -->
        <div class='row'>
            <div class='row left-align primary-font-color subtitle'>
                <h2>{lang.map}</h2>
            </div>
        </div>
        <div class='row'>
            <Map zoomMap={10} services={[selectedService]} moveToCenter={true}/>
        </div>
    </div>
</div>

<style>
    .zoom-img{
        object-fit: contain;
    }

    .like-button-box {
        display: inline-block;
        line-height: 25px;
        transform: translateY(-4px);
    }

    .details-inner {
        min-height: 200px;
    }

    .details-inner a {
        text-decoration: underline;
    }

    .subtitle {
        width: 100%;
        border-bottom: 1px solid rgba(134, 133, 133, 0.86);
        padding: 10px 0px;
        margin: 20px 0px;
    }

    .subtitle > h2 {
        position: relative;
    }

    .subtitle > h2:before {

    }

    .caption {
        width: 40%;
        max-width: 200px;
        margin-bottom: 1rem;
    }

    .caption::after {
        content: ' :';
        width: 2rem;
    }

    .value {
        width: 60%;
    }

    .table-row {
        padding: 10px 0px;
        font-size: 1rem;
        margin-bottom: 1.5rem;
    }


    .long-desc {
        font-size: 1rem;
        line-height: 2rem;
    }


    @media screen and (max-width: 1000px) {
        .details-inner {
            padding: 10px 20px;
        }
    }
</style>